import { render, staticRenderFns } from "./change_psw.vue?vue&type=template&id=55dcca49&scoped=true&"
import script from "./change_psw.vue?vue&type=script&lang=js&"
export * from "./change_psw.vue?vue&type=script&lang=js&"
import style0 from "./change_psw.vue?vue&type=style&index=0&id=55dcca49&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dcca49",
  null
  
)

export default component.exports